import React from "react";

const UpsellPopupOverlay = ({ children }) => {
  return <div className="screen-overlay--loadingPaypal screen-overlay">{children}</div>;
};

export default UpsellPopupOverlay;
